export function getDriveTourComplete() {
  return localStorage.getItem("driveTourComplete") || false;
}

export function getNarrativeComplete() {
  return localStorage.getItem("narrativeComplete") || false;
}

export function getSortTourComplete() {
  return localStorage.getItem("sortTourComplete") || false;
}

export function setDriveTourComplete(complete) {
  localStorage.setItem("driveTourComplete", complete);
}

export function setNarrativeComplete(complete) {
  localStorage.setItem("narrativeComplete", complete);
}

export function setSortTourComplete(complete) {
  localStorage.setItem("sortTourComplete", complete);
}
